document.addEventListener("DOMContentLoaded", () => {
	initModalAutoAppearing();
});

function initModalAutoAppearing() {
	let modalEl = document.querySelector("#needMoneyModal");
	if (!modalEl) return;

	let defaultTimeout = 60000;
	let onGone = modalEl.dataset.onGone;
	let onTimeout = modalEl.dataset.onTimeout;
	let timeout = modalEl.dataset.modalTimeout ? modalEl.dataset.modalTimeout * 1000 : defaultTimeout;
	let itemName = "needMoneyModal";
	let sessionItem = sessionStorage.getItem(itemName);
	if (!sessionItem) {
		let modal = bootstrap.Modal.getOrCreateInstance(modalEl);
		let t;
		if (onGone) {
			document.addEventListener("mouseleave", handleMouseLeave);
		}
		if (onTimeout) {
			runTimeout();
		}

		function runTimeout() {
			t = setTimeout(() => {
				modal.show();
				sessionStorage.setItem(itemName, "true");
				document.removeEventListener("mouseleave", handleMouseLeave);
			}, timeout);
		}

		function handleMouseLeave(e) {
			modal.show();
			sessionStorage.setItem(itemName, "true");
			document.removeEventListener("mouseleave", handleMouseLeave);
			clearTimeout(t);
		}
	}
}
